import React from "react";
import CurrEmployeeDetails from "../../component/CurrEmployeeDetails/CurrEmployeeDetails.tsx";

const CurrentEmployeeDetails = () => {
  return <CurrEmployeeDetails />;
};

export default CurrentEmployeeDetails;
